// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"df7d6478","295":"c7e7b34a","417":"c71467df","483":"df7d6478","664":"337b38a4","702":"66f606ba"}[chunkId] + ".chunk.css";
};